import { View, StyleSheet, Pressable, Platform } from 'react-native';
import Text from 'theme/Text';
import { textProps } from 'styles/text'
import { colorList } from 'utils/colors'

const BottomNavigation = ({ children, vertical = false, floating = false }) => {

    return (
        <View
            style={[
				styles.container,
				vertical ? styles.containerVertical : null,
				floating ? styles.containerFloating : null,
			]}>

            { children }
        </View>
    )
}

export const BottomNavigationTab = ({ title, icon, isSelected = false, onPress, vertical = false, floating = false }) => {

    return (
        <Pressable
            style={({ pressed }) => {
                return (
                    [
                        styles.pressable,
                        vertical ? styles.pressableVertical : null,
                        floating ? styles.pressableFloating : null,
                        pressed ? styles.pressablePressed : null,
                    ]
                );
            }}
            onPress={ onPress }
            accessibilityRole="tab"
            accessibilityLabel={ title }
            accessibilityState={{ selected: isSelected }}>

            <View
                collapsable={ false }
                style={[
					styles.item,
					floating ? styles.itemFloating : null,
					isSelected ? styles.itemSelected : null,
					isSelected && floating ? styles.itemSelectedFloating : null,
				]}>

                <View 
                    style={ styles.itemIcon }>

                    { icon && icon() }
                </View>
                
                <Text
                    { ...textProps.fit }
                    style={[
                        styles.itemText,
                        {
                            color: isSelected ? colorList.PRIMARY.dark : colorList.TEXT.light,
                            fontWeight: isSelected ? '700' : '500',
                        }
                    ]}>
                    
                    { title }
                </Text>
            </View>
        </Pressable>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        backgroundColor: '#fff',
    },
	containerVertical: {
		flex: 1,
		flexDirection: 'column',
		justifyContent: 'center',
		paddingVertical: 12,
	},
	containerFloating: {
		backgroundColor: 'transparent',
	},

    pressable: {
        flex: 1,
        minHeight: 56,
        paddingHorizontal: 3,
        paddingVertical: 4,
    },
	pressablePressed: {
        opacity: 0.65,
    },
	pressableFloating: {
		minHeight: 58,
		paddingHorizontal: 2,
		paddingVertical: 2,
	},
	pressableVertical: {
		width: '100%',
		minWidth: 96,
		minHeight: 68,
		maxHeight: 84,
	},

    item: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 12,
        // Clipping can hide Android tab content when the selected background changes.
    },
    itemSelected: {
        backgroundColor: colorList.ORANGE.subtle,
    },
	itemFloating: {
		borderRadius: 24,
	},
	itemSelectedFloating: {
		backgroundColor: 'rgba(255, 255, 255, 0.76)',
		borderWidth: 1,
		borderColor: 'rgba(255, 255, 255, 0.9)',
		shadowColor: colorList.PRIMARY.dark,
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.10,
		shadowRadius: 6,
		// Keep Android tab content out of a translucent elevated layer when switching tabs.
		// ...Platform.select({
		// 	android: {
		// 		backgroundColor: '#ffffff',
		// 		elevation: 0,
		// 	},
		// 	default: {
		// 		elevation: 2,
		// 	},
		// }),
	},

    itemIcon: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    itemText: {
        fontSize: 12,
        maxWidth: '90%',
        marginTop: 2,
		textAlign: 'center',
        color: 'red'
    }
})

export default BottomNavigation;
